import reducer from "./reducers/index";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import rootSaga from './saga/index'
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const TRANSIENT_STATE_KEYS = ['cardetail', 'cardeailupdate', 'loader', 'toaster'];

const migrations = {
  1: (state) => {
    if (!state) return state;
    const next = { ...state };
    TRANSIENT_STATE_KEYS.forEach((key) => {
      delete next[key];
    });
    return next;
  },
};

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: TRANSIENT_STATE_KEYS,
  migrate: createMigrate(migrations, { debug: false }),
};
const pReducer = persistReducer(persistConfig, reducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware];

const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);
const persistor = persistStore(store);
// run saga
sagaMiddleware.run(rootSaga);

export default {persistor,store};
